<script lang="ts">
  import { navigate } from 'svelte-routing';
</script>

<svelte:head>
  <title>Signup Not Found - outlive.it</title>
</svelte:head>

<section id="main" class="main">
  <header>
    <h2>Signup Not Found</h2>
  </header>

  <p>
    We couldn't find your signup or it has expired.
  </p>
  <p>
    Signup confirmations expire after 2 days. Please try signing up again.
  </p>
  <p>
    <a href="/" class="button" on:click|preventDefault={() => navigate('/')}>Return to home</a>
  </p>
</section>

<style>
  #main {
    padding: 4em;
    background-color: #ffffff;
    border-radius: 4px;
    text-align: center;
  }

  #main > header:first-child {
    text-align: center;
  }

  @media screen and (max-width: 736px) {
    #main {
      padding: 2em;
    }
  }
</style>
